import { Button } from "@material-ui/core"
import styled from "styled-components"

const StyledButtonContainer = styled(Button)<{
  $width?: number | "auto"
  $mobileWidth?: number | "auto"
  $btnType?: "filled" | "outlined"
  $disabled?: boolean
  $fullWidth?: boolean
  isdisabled?: boolean
}>`
  width: ${(p) => (p?.$width ? `${p?.$width}px` : "328px")};
  ${(p) => p?.$width === "auto" && "width: auto;"}
  ${(p) => p?.$fullWidth && "width: 100%;"}
  height: 48px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: ${(p) => (p?.$mobileWidth ? `${p?.$mobileWidth}px` : "100%")};
    ${(p) => p?.$mobileWidth === "auto" && "width: auto;"}
  }

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 8px;
  padding: 8px 16px;

  font-family: NarkisBlock;
  font-size: 24px;
  color: var(--Black, var(--Primary-Black, #000));

  cursor: pointer;

  // FILLED BUTTON STYLES
  ${(p) =>
    p?.$btnType === "filled" &&
    !p?.$disabled &&
    `
      background: var(--Yellow, #ffbc0d);

      &:hover {
        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);
        background: var(--Yellow, #ffbc0d);
        font-size: 26px;
      }

      &:focus {
        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);
      }

      &:active {
        background: #F5B511;
      }
    `}

  ${(p) =>
    p?.$btnType === "outlined" &&
    !p?.$disabled &&
    `
      border: 2px solid var(--Yellow, #FFBC0D);
      background: var(--White, #FFF);


      &:hover {
        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);
        background: var(--White, #FFF);
        font-size: 26px;
      }

      &:focus {
        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);
      }

      &:active {
        background: rgba(247, 247, 247, 0.50);
      }
  `}

  // DISABLED BUTTON STYLES
  ${(p) =>
    p?.$disabled &&
    `
      background: var(--Light-Grey, #F7F7F7);
      color: rgba(45, 45, 45, 0.72);
    `}

${(p) =>
    p.isdisabled &&
    `
    background: var(--Light-Grey, #f7f7f7);
    color: rgba(45, 45, 45, 0.72);
    font-size: 24px;
    :hover {
    background: var(--Light-Grey, #f7f7f7);

  }
  `}
`

const StyledIcon = styled.span``

type GenericButtonProps = {
  btnType: "filled" | "outlined"
  children: any
  width?: number | "auto"
  mobileWidth?: number | "auto"
  icon?: string
  disabled?: boolean
  onClick?: any
  type?: "button" | "submit" | "reset"
  className?: string
  endIcon?: any
  fullWidth?: boolean
  buttonHref?: string
  isdisabled?: boolean
}

const GenericButton = ({
  btnType,
  width,
  mobileWidth,
  icon,
  children,
  disabled,
  onClick,
  type,
  className,
  endIcon,
  fullWidth,
  buttonHref,
  isdisabled,
}: GenericButtonProps) => {
  return (
    <StyledButtonContainer
      $width={width}
      $mobileWidth={mobileWidth}
      $btnType={btnType}
      $disabled={disabled}
      $fullWidth={fullWidth}
      onClick={onClick}
      disabled={disabled}
      type={type}
      isdisabled={isdisabled}
      className={className}
      href={buttonHref}
    >
      {icon && <StyledIcon>{icon}</StyledIcon>}
      {children}
      {endIcon && <StyledIcon>{endIcon}</StyledIcon>}
    </StyledButtonContainer>
  )
}

export default GenericButton
